import React from 'react';
import "./Home.scss";
import SEO from '../../components/SEO';
import photoIntro from '../../assets/images/intro2.jpg'

const Home = () => {
  return (
    <>
      <SEO 
        title="Claire Landais Sauvage - Céramiste et Poète"
        description="Accueil - Des bols simples, créés lentement, avec des argiles glanées dans la nature et cuits en four à bois, pour une communion avec le monde vivant."
        url="https://clairelandaissauvage.fr/"
      />
      <div className="intro-page">
          <div className="photoIntro_content">
            <img className="photoIntro" src={photoIntro} alt="Portrait artistique de Claire Landais Sauvage" />
          </div>
          <h1>claire landais sauvage</h1>
        </div>
    </>
  );
};

export default Home;